/* Tail Tales Hub theme scripts (no dependencies) */
(function () {
  'use strict';
  var routes = (window.theme && window.theme.routes) || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- overlays: menu, search, filters ---------- */
  function setOpen(el, open, trigger) {
    if (!el) return;
    if (open) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  /* ---------- cart drawer + ajax cart ---------- */
  function drawer() { return $('#cart-drawer'); }
  function openDrawer() {
    var d = drawer(); if (!d) return false;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var close = $('[data-cart-close]', d); if (close) close.focus();
    return true;
  }
  function closeDrawer() {
    var d = drawer(); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }
  function refreshCart(keepOpen) {
    var wasOpen = drawer() && drawer().classList.contains('is-open');
    return Promise.all([
      fetch(routes.root + '?sections=cart-drawer').then(function (r) { return r.json(); }),
      fetch('/cart.js').then(function (r) { return r.json(); })
    ]).then(function (res) {
      var html = res[0]['cart-drawer'];
      var holder = $('#shopify-section-cart-drawer');
      if (html && holder) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('#shopify-section-cart-drawer') || doc.body;
        holder.innerHTML = inner.innerHTML;
        if (wasOpen || keepOpen) { var d = drawer(); if (d) { d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); } }
      }
      $$('[data-cart-count]').forEach(function (el) { el.textContent = res[1].item_count; });
    });
  }
  function ajaxAdd(form) {
    var btn = $('[type="submit"]', form);
    if (btn) btn.disabled = true;
    return fetch(routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) { throw new Error(res.body.description || res.body.message || 'Could not add to cart'); }
        return refreshCart(true).then(function () { openDrawer(); });
      })
      .catch(function (err) {
        var msg = form.querySelector('.form-error');
        if (!msg) { msg = document.createElement('p'); msg.className = 'notice notice--error form-error'; msg.setAttribute('role', 'alert'); form.appendChild(msg); }
        msg.textContent = err.message;
      })
      .then(function () { if (btn) btn.disabled = false; });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches && form.matches('form[action*="/cart/add"]')) {
      if (!drawer()) return;
      e.preventDefault();
      ajaxAdd(form);
    }
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest('button, a, [data-cart-close]');
    if (!t) return;

    if (t.matches('[data-menu-open]')) { setOpen($('#mobile-menu'), true, t); return; }
    if (t.matches('[data-menu-close]')) { setOpen($('#mobile-menu'), false, $('[data-menu-open]')); return; }
    if (t.matches('[data-search-open]')) {
      var so = $('#search-overlay'); setOpen(so, so.hasAttribute('hidden'), t);
      if (!so.hasAttribute('hidden')) { var i = $('#overlay-search'); if (i) i.focus(); }
      return;
    }
    if (t.matches('[data-search-close]')) { setOpen($('#search-overlay'), false, $('[data-search-open]')); return; }
    if (t.matches('[data-filters-open]')) { var f = $('#filters'); if (f) { f.classList.add('is-open'); t.setAttribute('aria-expanded', 'true'); } return; }
    if (t.matches('[data-filters-close]')) { var f2 = $('#filters'); if (f2) f2.classList.remove('is-open'); var fb = $('[data-filters-open]'); if (fb) fb.setAttribute('aria-expanded', 'false'); return; }

    if (t.matches('[data-cart-open]')) {
      if (document.body.classList.contains('template-cart')) return;
      if (openDrawer()) e.preventDefault();
      return;
    }
    if (t.matches('[data-cart-close]')) { closeDrawer(); return; }
    if (t.matches('[data-cart-change]')) {
      var line = parseInt(t.getAttribute('data-line'), 10);
      var qty = parseInt(t.getAttribute('data-quantity'), 10);
      t.disabled = true;
      fetch(routes.cartChange + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function () { return refreshCart(true); });
      return;
    }

    /* quantity steppers */
    if (t.matches('[data-qty-minus],[data-qty-plus]')) {
      var wrap = t.closest('.qty'); var input = $('[data-qty-input]', wrap);
      var min = input.hasAttribute('min') ? parseInt(input.min, 10) : 1;
      var v = (parseInt(input.value, 10) || 0) + (t.hasAttribute('data-qty-plus') ? 1 : -1);
      input.value = Math.max(min, v);
      if (input.hasAttribute('data-qty-submit')) { input.form.submit(); }
      return;
    }

    /* gallery */
    if (t.matches('[data-gallery-thumb]')) {
      var main = $('[data-gallery-main] img');
      if (main) { main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = t.getAttribute('data-src'); main.alt = t.getAttribute('data-alt') || ''; }
      $$('[data-gallery-thumb]').forEach(function (b) { b.classList.toggle('is-active', b === t); });
      return;
    }

    /* discount code */
    if (t.matches('[data-discount-apply]')) {
      var code = $('[data-discount-input]');
      if (code && code.value.trim()) {
        window.location.href = '/discount/' + encodeURIComponent(code.value.trim()) + '?redirect=' + encodeURIComponent(routes.cart);
      }
      return;
    }

    /* login <-> recover */
    if (t.matches('[data-recover-toggle]')) {
      var lp = $('#login-panel'), rp = $('#recover-panel');
      if (lp && rp) { var showRecover = rp.hasAttribute('hidden'); setOpen(rp, showRecover); setOpen(lp, !showRecover); }
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDrawer();
    setOpen($('#mobile-menu'), false, $('[data-menu-open]'));
    setOpen($('#search-overlay'), false, $('[data-search-open]'));
    var f = $('#filters'); if (f) f.classList.remove('is-open');
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-auto-submit]')) { e.target.form.submit(); }
    if (e.target.matches('[data-qty-submit]')) { e.target.form.submit(); }
  });

  /* show recover panel when Shopify returns from a recover submit */
  if (window.location.hash === '#recover') {
    var lp = $('#login-panel'), rp = $('#recover-panel');
    if (lp && rp) { setOpen(rp, true); setOpen(lp, false); }
  }

  /* ---------- product variants ---------- */
  function initProduct(section) {
    var jsonEl = $('[data-product-json]', section); if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = $('form[action*="/cart/add"]', section);
    var idInput = $('[data-variant-id]', section);
    var priceBox = $('[data-product-price]', section);
    var addBtn = $('[data-add-btn]', section);
    var notify = $('[data-notify]', section);
    var sticky = $('[data-sticky-buy]', section);
    var stickyBtn = $('[data-sticky-btn]', section);
    var stickyPrice = $('[data-sticky-price]', section);
    var money = function (cents) {
      var fmt = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: fmt }).format(cents / 100); }
      catch (err) { return '$' + (cents / 100).toFixed(2); }
    };
    function selected() {
      return $$('fieldset[data-option-index]', section).map(function (fs) {
        var c = $('input:checked', fs); return c ? c.value : null;
      });
    }
    function update() {
      if (product.variants.length <= 1) return;
      var opts = selected();
      var v = product.variants.filter(function (variant) {
        return opts.every(function (val, i) { return variant.options[i] === val; });
      })[0];
      if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; if (stickyBtn) stickyBtn.disabled = true; return; }
      idInput.value = v.id;
      priceBox.innerHTML = '<div class="price' + (v.compare_at_price > v.price ? ' price--sale' : '') + '">' +
        (v.compare_at_price > v.price ? '<s class="price__compare">' + money(v.compare_at_price) + '</s>' : '') +
        '<span class="price__current">' + money(v.price) + '</span></div>';
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (notify) notify.hidden = v.available;
      if (sticky) sticky.hidden = !v.available;
      if (stickyBtn) stickyBtn.disabled = !v.available;
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (v.featured_media) {
        var main = $('[data-gallery-main] img');
        var thumb = product.media.filter(function (m) { return m.id === v.featured_media.id; })[0];
        var btn = thumb && $$('[data-gallery-thumb]', section)[product.media.indexOf(thumb)];
        if (btn) btn.click();
      }
      if (window.history && history.replaceState) {
        history.replaceState({}, '', window.location.pathname + '?variant=' + v.id);
      }
    }
    $$('fieldset[data-option-index] input', section).forEach(function (i) { i.addEventListener('change', update); });
  }
  $$('[data-product-section]').forEach(initProduct);
})();
